export default __webpack_public_path__ + "static/media/back2.e07dcce9.jpg";